// extracted by mini-css-extract-plugin
module.exports = {"cursor-pointer":"styles-module__cursor-pointer___1s95I","blue-border":"styles-module__blue-border___1MMfC","box-shadow":"styles-module__box-shadow___3WwNp"};